export enum LangueEnseignement {
  FRANCAIS = 'FRANCAIS',
  AUTRES = 'AUTRES',
}
